<up-top-header />
<div class="dark-gradient-background full-width">
  <router-outlet></router-outlet>
</div>

<!-- <div class="user-topbar flex justify-between full-width padding-large">
  <img class="hover"
       src="https://basicplatformblob.blob.core.windows.net/resources/LOGOS/BASICNET.PNG">
  <div><button><i class="fa fa-sign-in"></i>Login</button></div>
</div> -->
